var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3548_23448",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 28,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45256 6.41337C9.68598 6.25237 12.2007 6.17188 13.9974 6.17188C15.7941 6.17188 18.31 6.25237 21.5451 6.41396C22.3917 6.45621 23.1942 6.80425 23.8036 7.39344C24.4129 7.98264 24.7878 8.77295 24.8585 9.61762C25.0066 11.3875 25.0807 12.9461 25.0807 14.2942C25.0807 15.6586 25.0049 17.2389 24.8532 19.0355C24.7828 19.8705 24.4152 20.6525 23.8171 21.2394C23.2191 21.8264 22.4303 22.1792 21.5941 22.234C18.8286 22.4148 16.2963 22.5052 13.9974 22.5052C11.6991 22.5052 9.1674 22.4148 6.40356 22.234C5.56769 22.1793 4.77913 21.8267 4.18112 21.2401C3.5831 20.6535 3.21529 19.872 3.14448 19.0373C2.99106 17.2272 2.91406 15.6458 2.91406 14.2942C2.91406 12.9584 2.98931 11.3991 3.13865 9.61588C3.20963 8.77141 3.58458 7.98138 4.19392 7.39242C4.80326 6.80347 5.60617 6.45559 6.45256 6.41337Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.7777V16.9087C12.25 16.999 12.2744 17.0877 12.3208 17.1653C12.3671 17.2428 12.4336 17.3064 12.5132 17.3492C12.5928 17.392 12.6825 17.4124 12.7728 17.4083C12.863 17.4041 12.9505 17.3756 13.0258 17.3257L16.8741 14.7824C16.9429 14.7371 16.9994 14.6754 17.0386 14.603C17.0778 14.5305 17.0985 14.4495 17.0988 14.3671C17.0992 14.2848 17.0792 14.2036 17.0406 14.1308C17.002 14.058 16.946 13.9959 16.8776 13.95L13.0287 11.3623C12.9535 11.3118 12.866 11.2826 12.7755 11.278C12.685 11.2734 12.5949 11.2934 12.5149 11.336C12.4349 11.3786 12.368 11.4422 12.3214 11.5199C12.2747 11.5975 12.25 11.6865 12.25 11.7771V11.7777Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.429,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3548_23448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.335938H28V28.3359H0V0.335938Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.82b889fd03b66b6453ea07a6fa8b6174.svg";
export { ForwardRef as ReactComponent };